export default "__VITE_ASSET__BAiDRIrQ__";